import {FaUser, FaFileInvoiceDollar} from "react-icons/fa";
import {AiFillHome, AiOutlineDollar, AiOutlineFileSearch, AiOutlineMail, AiOutlinePlusCircle, AiOutlineRobot} from "react-icons/ai";
import {BiCog} from "react-icons/bi";
import {GiHealthNormal} from "react-icons/gi";
import {BsViewStacked} from "react-icons/bs";
import { HiAcademicCap } from "react-icons/hi";
import { FormattedMessage } from "react-intl";
import { FaTeethOpen } from "react-icons/fa";
import { CiDeliveryTruck } from "react-icons/ci";
import { IoMdStats } from "react-icons/io";
import { TbUsers, TbDental } from "react-icons/tb";

export const doctorLinks = [
    {
        title: <FormattedMessage id="dshbrd" defaultMessage={"Dashboard"} />,
        icon: AiFillHome,
        to: "/"
    },
    {
        title: <FormattedMessage id="m.p" defaultMessage={"My Profile"} />,
        icon: FaUser,
        to: "/profile"
    },
    {
        title: <FormattedMessage id="team" defaultMessage={"Team"} />,
        icon: TbUsers,
        to: "/team",
        only_doctor: true
    },
    {
        title: <FormattedMessage id="deliveries" defaultMessage={"My Deliveries"} />,
        icon: CiDeliveryTruck,
        to: "/deliveries"
    },
    {
            title: <FormattedMessage id="ai_indexes" defaultMessage={"AI Indexes"} />,
            icon: AiOutlineRobot,
            to: "/ai",
        },
    {
        title: <FormattedMessage id="ceph_analysis" defaultMessage={"Ceph Analysis"} />,
        icon: TbDental,
        to: "/ceph-analysis",
    },
    {
        title: <FormattedMessage id="v.crses" defaultMessage={"View Courses"} />,
        icon: HiAcademicCap,
        to: "/courses"
    },
    {
        title: <FormattedMessage id="stats" defaultMessage={"Statistics"} />,
        icon: IoMdStats,
        to: "/statistics"
    },
    {
        title: <FormattedMessage id="patients" defaultMessage={"Patients"} />,
        icon: FaTeethOpen,
        to: "/patients"
    },
    {
        title: <FormattedMessage id="inv" defaultMessage={"Invoices"} />,
        icon: FaFileInvoiceDollar,
        only_doctor: true,
        links: [
            {
                title: <FormattedMessage id="a.bil.m" defaultMessage={"Add Billing Methods"} />,
                icon: AiOutlinePlusCircle,
                to: "/billing/methods/add"
            },
            {
                title: <FormattedMessage id="bil.m" defaultMessage={"Billing Methods"} />,
                icon: AiOutlineDollar,
                to: "/billing/methods"
            },
            {
                title: <FormattedMessage id="inv" defaultMessage={"Invoices"} />,
                icon: AiOutlineFileSearch,
                to: "/billing"
            },
        ]
        
    },
    {
        only_doctor: true,
        title: <FormattedMessage id="clncs" defaultMessage={"Clinics"}/>,
        icon: GiHealthNormal,
        links: [
            {
                title: <FormattedMessage id="a.clncs" defaultMessage={"Add Clinics"}/>,
                icon: AiOutlinePlusCircle,
                to: "/clinics/add"
            },
            {
                title: <FormattedMessage id="v.clncs" defaultMessage={"View Clinics"}/>,
                icon: BsViewStacked,
                to: "/clinics"
            },
        ]
        
    },
    {
        only_subdoctor: true,
        title: <FormattedMessage id="v.clncs" defaultMessage={"View Clinics"}/>,
        icon: BsViewStacked,
        to: "/clinics"
    },
    {
        title: <FormattedMessage id="cses" defaultMessage={"Cases"}/>,
        icon: GiHealthNormal,
        user_noti: true,
        links: [
            {
                title: <FormattedMessage id="a.cse" defaultMessage={"Add Cases"}/>,
                icon: AiOutlinePlusCircle,
                to: "/cases/add",

            },
            {
                title: <FormattedMessage id="v.cses" defaultMessage={"View Cases"}/>,
                icon: BsViewStacked,
                to: "/cases",
                user_noti: true,
            },
        ]
        
    },
    {
        title: <FormattedMessage id="case_studies" defaultMessage={"Case Studies"}/>,
        icon: GiHealthNormal,
        to: "/case-studies",
    },
    {
        title: <FormattedMessage id="support" defaultMessage={"Support"}/>,
        icon: AiOutlineMail,
        to: "/support",
        support_noti: true

    },
]